import { format } from 'date-fns'
import * as React from 'react'
import { TabbedCard } from '../tabbed-card'
import { Team } from '../types'
import { useWfiContext } from '../WfiContext'
import { CurrentImpact } from './CurrentImpact'
import { CurrentSkills } from './CurrentSkills'

export type CurrentOrgSummaryProps = {
  teams: Team[]
}

export const CurrentOrgSummary: React.VFC<CurrentOrgSummaryProps> = ({
  teams,
}) => {
  const [collapsed, setCollapsed] = React.useState(false)
  const [selectedTeam, setSelectedTeam] = React.useState<number | null>(null)
  const { orgSnapshot } = useWfiContext()

  const teamsWithSelection = teams.map((team) => ({
    ...team,
    selected: team.id === selectedTeam,
  }))

  return (
    <TabbedCard
      collapsed={collapsed}
      onToggleCollapsed={() => setCollapsed((c) => !c)}
      onTeamSelect={(id) => setSelectedTeam(id)}
      selectedTeam={selectedTeam}
      /* eslint-disable react/jsx-key */
      tabs={[
        [
          'Impact',
          <CurrentImpact
            onSelect={setSelectedTeam}
            selectedTeam={selectedTeam}
            teams={teamsWithSelection}
          />,
        ],
        [
          'Skills',
          <CurrentSkills
            selectedTeam={selectedTeam}
            teams={teamsWithSelection}
          />,
        ],
      ]}
      /* eslint-enable react/jsx-key */
      teams={teamsWithSelection}
      title={`Organization Summary${
        orgSnapshot != null &&
        ' · ' + format(orgSnapshot.timestamp, 'MMM d, yyyy')
      }`}
    />
  )
}
